var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    y: 0.5,
    fill: "#5B7FA6",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.342 8.853c.114-.369 0-.639-.538-.639h-1.782c-.454 0-.661.234-.775.49 0 0-.906 2.155-2.19 3.551-.415.407-.604.535-.83.535-.113 0-.277-.128-.277-.497v-3.44c0-.442-.13-.639-.509-.639h-2.8c-.283 0-.454.205-.454.4 0 .418.642.514.708 1.693v2.557c0 .56-.103.663-.33.663-.605 0-2.074-2.162-2.946-4.637-.17-.48-.342-.675-.797-.675H4.041c-.51 0-.611.234-.611.49 0 .461.604 2.743 2.813 5.76 1.472 2.06 3.545 3.178 5.434 3.178 1.132 0 1.272-.248 1.272-.676V15.41c0-.496.108-.596.467-.596.263 0 .716.13 1.774 1.123 1.208 1.177 1.407 1.705 2.086 1.705h1.782c.508 0 .763-.248.616-.738-.16-.487-.737-1.196-1.502-2.035-.416-.478-1.038-.993-1.227-1.25-.265-.332-.188-.479 0-.774 0 .001 2.171-2.979 2.397-3.992"
  })));
};
export default SvgVk;